import { assertEx, EthAddress } from '@xylabs/sdk-js'
import { BaseJsonObject, Quadkey, XyoWorldBase, XyoWorldGeotokens } from '@xyo-network/sdk-xyoworld-js'

export interface XyoWorldEntityGeotokensJsonObject extends BaseJsonObject {
  address: string
}

class EntityGeotokens extends XyoWorldBase<XyoWorldEntityGeotokensJsonObject> {
  public address: EthAddress
  public geotokenCount?: number
  public landArea?: number
  public ownedQuadkeys?: Quadkey[]
  private geotokens: XyoWorldGeotokens

  constructor(address: EthAddress, geotokens: XyoWorldGeotokens) {
    super()
    this.address = address
    this.geotokens = geotokens
  }

  public async fetchGeotokenCount() {
    return (this.geotokenCount = (await this.fetchOwnedQuadkeys())?.length)
  }

  public async fetchOwnedQuadkeys() {
    console.warn('fetchOwnedQuadkeys')
    return (this.ownedQuadkeys = await this.geotokens.wrapper.getQuadkeysByOwner(this.address))
  }

  public async getGeotokenCount() {
    return this.geotokenCount ?? (await this.fetchGeotokenCount())
  }

  public async getLandArea(depth = 10) {
    const quadkeys = await this.getOwnedQuadkeys()
    if (quadkeys) {
      let area = 0
      for (const quadkey of quadkeys) {
        area = area + Math.pow(4, depth - quadkey.zoom())
      }
      return (this.landArea = area)
    }
  }

  public async getOwnedQuadkeys() {
    return this.ownedQuadkeys ?? (await this.fetchOwnedQuadkeys())
  }

  public async load() {
    await this.getOwnedQuadkeys()
    await this.getGeotokenCount()
    await this.getLandArea()
  }

  loadJsonObject(jsonObject?: XyoWorldEntityGeotokensJsonObject) {
    if (jsonObject) {
      this.address = assertEx(EthAddress.fromString(jsonObject.address), 'Bad address')
    }
    return this
  }

  toJsonObject(): XyoWorldEntityGeotokensJsonObject {
    return {
      address: this.address.toString(),
    }
  }
}

export default EntityGeotokens
